var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReset = function SvgReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "reset_svg__mie-2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.3c0-4.13-3.38-7.5-7.5-7.5a7.38 7.38 0 0 0-6.68 4.12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1.73 1.5.6 4.42 4.5-.6m7.62 9.14c.49-.52.9-1.13 1.23-1.79M9.19 16.8a7.53 7.53 0 0 0 2.4-.45m-7.94-1.81c.58.6 1.27 1.1 2.02 1.48M1.5 9.3c0 .78.12 1.54.35 2.25",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
};
export default SvgReset;